module.exports = __webpack_public_path__ + "static/01-809c7aacfe9c10ff608ff868feddd025.jpg";